import LoginPage from "./LoginContainer";

export default LoginPage;
